var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElementNumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 50,
    viewBox: "0 0 32 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 18,
    width: 30,
    height: 14,
    rx: 1,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.808 29.144C7.504 29.144 7.224 29.112 6.968 29.048C6.72 28.992 6.492 28.916 6.284 28.82C6.084 28.724 5.9 28.616 5.732 28.496C5.572 28.368 5.428 28.236 5.3 28.1L5.78 27.452C6.004 27.684 6.268 27.888 6.572 28.064C6.884 28.24 7.264 28.328 7.712 28.328C7.944 28.328 8.16 28.288 8.36 28.208C8.568 28.12 8.748 28 8.9 27.848C9.052 27.696 9.172 27.512 9.26 27.296C9.348 27.08 9.392 26.84 9.392 26.576C9.392 26.048 9.244 25.636 8.948 25.34C8.652 25.044 8.256 24.896 7.76 24.896C7.496 24.896 7.268 24.936 7.076 25.016C6.892 25.096 6.684 25.212 6.452 25.364L5.924 25.028L6.176 21.344H10.004V22.196H7.04L6.836 24.464C7.02 24.368 7.204 24.292 7.388 24.236C7.572 24.18 7.78 24.152 8.012 24.152C8.34 24.152 8.648 24.2 8.936 24.296C9.224 24.392 9.476 24.54 9.692 24.74C9.908 24.932 10.076 25.18 10.196 25.484C10.324 25.78 10.388 26.136 10.388 26.552C10.388 26.968 10.316 27.336 10.172 27.656C10.028 27.976 9.836 28.248 9.596 28.472C9.356 28.688 9.08 28.856 8.768 28.976C8.464 29.088 8.144 29.144 7.808 29.144Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementNumber);
export default __webpack_public_path__ + "static/media/element_number.45274a03ca00ebdb5fd4143371f599e2.svg";
export { ForwardRef as ReactComponent };